<!-- AI页面选择 -->
<template>
  <div class="interface">
    <!-- 导航栏 -->
    <div class="navigation">
      <div class="back" @click="Previouspage()"><<<</div>
      <img :src="logUrlList.home" class="home_img" @click="Maininterface()" />
    </div>
    <div class="subject">
      <div class="header"></div>
      <div class="main">
        <!-- 文生图 -->
        <div class="process" @click="AItext_to_image()">
          <img class="process_img" :src="logUrlList.text_image" />
          <div class="process_time">
            <div class="process_name">{{ process01 }}</div>
            <div class="process_explanation">{{ explanation01 }}</div>
          </div>
        </div>
        <!-- 图文生图 -->
        <div class="process" @click="AIimage_text_to_image()">
          <img class="process_img" :src="logUrlList.textandimage_image" />
          <div class="process_time">
            <div class="process_name">{{ process02 }}</div>
            <div class="process_explanation">{{ explanation02 }}</div>
          </div>
        </div>
        <!-- 图生图 -->
        <div class="process" @click="AIimage_to_image()">
          <img class="process_img" :src="logUrlList.image_image" />
          <div class="process_time">
            <div class="process_name">{{ process03 }}</div>
            <div class="process_explanation">{{ explanation03 }}</div>
          </div>
        </div>
        <!-- <div class="process">
          <img class="process_img" :src="logUrlList.cat" />
          <div class="process_time">
            <div class="process_name">{{ process04 }}</div>
            <div class="process_explanation"></div>
          </div>
        </div> -->
        <hr />
        <div class="explanation">
          <div class="explanation_name">说明：</div>
          <div class="explanation_info">{{ explanation04 }}</div>
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </div>
</template>
<script>
const logUrl = require("@/common/logUrl.js");
const config = require("@/common/config.js");
export default {
  name: "AISelectCardface",
  data() {
    return {
      logUrlList: logUrl.logUrl,
      process01: "文生图",
      process02: "图文生图",
      process03: "图生图",
      process04: "后续功能敬请期待！",
      explanation01: "说明：根据您输入的文字描述或关键词生成图片。", //制卡说明
      explanation02: "说明：根据您输入的文字描述或关键词并上传图片后生成图片。", //制卡说明
      explanation03: "说明：根据您上传的图片，生成对应的图片", //制卡说明
      explanation04: ". 涉黄、涉暴、涉政等违规图片将无法审核通过。",
      errorMsg: "",
      bankSerialNumber: "",
      bankCode: "",
      selectParam: "",
    };
  },
  methods: {
    Previouspage() {
      this.$router.push({
        name: "SelectBusinessProcess",
      });
    },
    Maininterface() {
      this.$router.push({
        name: "HomePage",
      });
    },
    AItext_to_image() {
      var selectParam = JSON.stringify(this.selectParam);
      this.$router.replace({
        // 文生图
        name: "AItext_to_image",
        params: {
          // bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          selectParam: selectParam,
        },
      });
    },
    AIimage_text_to_image() {
      var selectParam = JSON.stringify(this.selectParam);
      this.$router.replace({
        // 图文生图
        name: "AIimage_text_to_image",
        params: {
          // bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          selectParam: selectParam,
        },
      });
    },
    AIimage_to_image() {
      var selectParam = JSON.stringify(this.selectParam);
      this.$router.replace({
        // 图生图
        name: "AIimage_to_image",
        params: {
          // bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          selectParam: selectParam,
        },
      });
    },
  },
  mounted() {
    // this.bankSerialNumber = this.$route.query.bankSerialNumber;
    // console.log("bankSerialNumber:" + this.bankSerialNumber);
    // this.radio = this.$route.query.radio;   //是否邮寄参数
    // console.log("radio:" + this.radio);
    this.bankCode = config.config_demo.bankCode;
    console.log("bankCode:" + this.bankCode);
    var selectParam = this.$route.params.selectParam;
    console.log("selectParam:" + selectParam);
    if (selectParam !== undefined) {
      this.selectParam = JSON.parse(selectParam);
    }
  },
};
</script>

<style scoped>
.navigation {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(left, #3861d5, white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
.subject {
  padding: 1.8rem 1.8rem 0;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* .header {
  background-color: aqua;
  height: 3rem;
} */
/* .main {
  background-color: yellow;
  height: 3rem;
} */
.process {
  width: 100%;
  background-color: #f4f5f7;
  border-radius: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1.2rem 0.6rem;
  margin-top: 1rem;
}
.process_img {
  width: 7.2rem;
  height: 4.2rem;
}
.process_time {
  width: 12rem;
  display: flex;
  flex-direction: column;
  justify-content: left;
  padding-left: 0.5rem;
}
.process_name {
  font-size: 0.8rem;
  font-weight: 700;
}
.process_explanation {
  font-size: 0.6rem;
}

.explanation {
  margin-top: 2rem;
}
.explanation_name {
  font-size: 1rem;
  font-weight: 600;
}
.explanation_info {
  font-size: 0.8rem;
}
/* .footer {
  background-color: blue;
  height: 3rem;
} */
</style>



// WEBPACK FOOTER //
// src/components/DIYApplyCardSurface/ApplicationCard/AIProcess/AISelectCardface.vue